import { setupAuthListener } from '@/lib/auth/broadcastChannel';
import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';

export function useAuthSync() {
  const router = useRouter();
  const { update } = useSession();

  // Stabilise references so the effect only runs once.
  // `update` from useSession() may be a new function ref on every render,
  // which previously re-ran the effect (and re-wired the BroadcastChannel
  // listener) on every session change – contributing to the burst loop.
  const routerRef = useRef(router);
  const updateRef = useRef(update);
  routerRef.current = router;
  updateRef.current = update;

  useEffect(() => {
    setupAuthListener(
      // Provide stable proxy objects so the listener always calls the
      // latest router / update without the effect needing to re-run.
      { replace: (...args) => routerRef.current.replace(...args), push: (...args) => routerRef.current.push(...args) },
      (...args) => updateRef.current(...args),
    );
  }, []); // run once on mount
}
